// TODO(observability): instrumentar SentItemsReport e DeParaReport com Application Insights
// — eventos customizados (solicitação enviada, tipo selecionado) e exceções de HTTP.
// Ref: architectural-decisions.md §Telemetria, specs/001-relatorio-itens-enviados/plan.md §Exceções/Desvios.
import React, { useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { differenceInDays } from "date-fns";
//services
import ReportService from "services/report.service";
//models
import { DeParaSearchType, TypeReport } from "models/Report";
//interfaces
import {
  ISentItemsReportFormState,
  ISentItemsReportModalProps,
  SentItemsReportType,
} from "./interface";
//styles
import {
  Chip,
  ChipRemoveButton,
  ChipsBlock,
  ChipsLabel,
  ChipsList,
  CloseButton,
  DateField,
  Dialog,
  DialogBox,
  DialogButtons,
  DialogContent,
  DialogIcon,
  DialogOutlineButton,
  DialogOverlay,
  DialogPrimaryButton,
  DialogSingleButton,
  DialogText,
  DialogTexts,
  DialogTitle,
  Divider,
  ErrorMessage,
  FieldLabel,
  FooterRow,
  HeaderRow,
  HiddenRadio,
  InputGroup,
  InputLabel,
  InputsRow,
  OutlineButton,
  Overlay,
  PeriodLabel,
  PeriodRow,
  PeriodSeparator,
  PrimaryButton,
  RadioCircle,
  RadioGroupRow,
  RadioLabel,
  SearchBlock,
  SearchBlockList,
  SearchInput,
  SearchInputWrapper,
  Section,
  SectionHeader,
  SectionHeaderDescription,
  SectionHeaderTitle,
  Title,
  TooltipAnchor,
  TooltipBox,
  WarningBanner,
} from "../DeParaReport/styles";

const MAX_PERIOD_DAYS = 31;
const MAX_CHIPS = 100;
const MIN_DATE = "2000-01-01";

const parseLocalDate = (value: string): Date | null => {
  if (!value) return null;
  const [y, m, d] = value.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

const INITIAL_STATE: ISentItemsReportFormState = Object.freeze({
  startDate: "",
  endDate: "",
  type: TypeReport.SENT_ITEMS_VIVEO,
  searchType: null,
  codeInput: "",
  codes: [],
  descriptionInput: "",
  descriptions: [],
  brandInput: "",
  brands: [],
}) as ISentItemsReportFormState;

const IconClose = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
    <path
      d="M1 1L13 13M13 1L1 13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconInfo = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <circle cx="8" cy="8" r="7" stroke="#5B5B5B" strokeWidth="1.2" />
    <rect x="7.3" y="6.8" width="1.4" height="5" rx="0.7" fill="#5B5B5B" />
    <circle cx="8" cy="4.7" r="0.9" fill="#5B5B5B" />
  </svg>
);

const IconSearch = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <circle cx="7.2" cy="7.2" r="4.4" stroke="#858585" strokeWidth="1.5" />
    <path
      d="M10.6 10.6L13.5 13.5"
      stroke="#858585"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const IconWarning = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path d="M8 3 L14 13 L2 13 Z" fill="#F9B609" />
    <rect x="7.5" y="6" width="1" height="5" fill="#FFFFFF" />
    <circle cx="8" cy="12" r="0.6" fill="#FFFFFF" />
  </svg>
);

const IconChipClose = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden>
    <path
      d="M1 1L7 7M7 1L1 7"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const IconMail = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    aria-hidden
  >
    <g clipPath="url(#sent-items-mail-clip)">
      <path
        d="M6.4 8h43.2c2.97 0 5.4 2.25 5.4 5v30c0 2.75-2.43 5-5.4 5H6.4C3.43 48 1 45.75 1 43V13c0-2.75 2.43-5 5.4-5z"
        fill="#E9FFFF"
      />
      <path
        d="M6 11h44a5 5 0 015 5v1L30.987 30.785a6 6 0 01-5.974 0L1 17v-1a5 5 0 015-5z"
        fill="#fff"
      />
      <path
        d="M6 8h44a5 5 0 015 5v1L30.987 27.785a6 6 0 01-5.974 0L1 14v-1a5 5 0 015-5z"
        fill="#6EE4D9"
      />
      <path
        d="M10 8H6.4C3.43 8 1 10.25 1 13v30c0 2.75 2.43 5 5.4 5h43.2c2.97 0 5.4-2.25 5.4-5V13c0-2.75-2.43-5-5.4-5H24M14 8h6"
        stroke="#0E4C54"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43 21l-11.932 7.16a6 6 0 01-6.146.016L1 14M55 14l-6 3.5"
        stroke="#0E4C54"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 41h-9a1.5 1.5 0 000 3h9a1.5 1.5 0 000-3zM37 42.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM32 42.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z"
        fill="#0E4C54"
      />
    </g>
    <defs>
      <clipPath id="sent-items-mail-clip">
        <path fill="#fff" d="M0 0H56V56H0z" />
      </clipPath>
    </defs>
  </svg>
);

const IconAlertTriangle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    aria-hidden
  >
    <g clipPath="url(#sent-items-alert-clip)">
      <path
        d="M31.955 6.318L54.32 44.68C56.193 47.892 53.973 52 50.366 52H5.634c-3.607 0-5.827-4.108-3.955-7.319L24.045 6.318c1.802-3.09 6.108-3.09 7.91 0z"
        fill="#FFFACA"
      />
      <path
        d="M49.26 36l5.06 8.681C56.194 47.892 53.974 52 50.367 52H5.634c-3.607 0-5.827-4.108-3.955-7.319L24.045 6.318c1.802-3.09 6.108-3.09 7.91 0L44.595 28"
        stroke="#F9B609"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <circle cx={29} cy={36} r={3} fill="#fff" />
      <path
        d="M32 19.462C32 21.373 30.657 31 29 31s-3-9.627-3-11.538C26 17.55 27.343 16 29 16s3 1.55 3 3.462z"
        fill="#fff"
      />
      <circle
        cx={28}
        cy={35}
        r={2}
        fill="#FAD566"
        stroke="#F9B609"
        strokeWidth={2}
      />
      <path
        d="M28 16c.975 0 2 .963 2 2.462 0 .857-.32 3.665-.858 6.285-.268 1.305-.578 2.504-.908 3.36a6.251 6.251 0 01-.234.54 6.251 6.251 0 01-.234-.54c-.33-.856-.64-2.055-.908-3.36-.537-2.62-.858-5.428-.858-6.285C26 16.963 27.025 16 28 16z"
        fill="#FAD566"
        stroke="#F9B609"
        strokeWidth={2}
      />
      <path
        d="M18.5 43h9a1.5 1.5 0 010 3h-9a1.5 1.5 0 010-3zM31 44.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM36 44.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM46 32a1 1 0 112 0 1 1 0 01-2 0z"
        fill="#F9B609"
      />
    </g>
    <defs>
      <clipPath id="sent-items-alert-clip">
        <path fill="#fff" d="M0 0H56V56H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const SentItemsReport: React.FC<ISentItemsReportModalProps> = ({
  isOpen,
  onClose,
}) => {
  const _reportServices = useMemo(() => new ReportService(), []);
  const [form, setForm] = useState<ISentItemsReportFormState>(INITIAL_STATE);
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState<string>("");
  const [pendingSearchType, setPendingSearchType] =
    useState<DeParaSearchType | null>(null);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);

  // Reset all state when modal closes
  useEffect(() => {
    if (!isOpen) {
      setForm(INITIAL_STATE);
      setFormError("");
      setSubmitting(false);
      setPendingSearchType(null);
      setShowSuccessDialog(false);
    }
  }, [isOpen]);

  // Keyboard Esc handler — blocked during submitting
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return;
      if (showSuccessDialog) {
        setShowSuccessDialog(false);
        onClose();
        return;
      }
      if (pendingSearchType !== null) {
        setPendingSearchType(null);
        return;
      }
      if (!submitting) onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose, showSuccessDialog, pendingSearchType, submitting]);

  const isViveo = form.type === TypeReport.SENT_ITEMS_VIVEO;
  const isCodeSearch = form.searchType === DeParaSearchType.PRODUCT_CODE;
  const isDescSearch = form.searchType === DeParaSearchType.DESCRIPTION_BRAND;

  // Adaptive text labels (FR-F-005, US3)
  const originLabel = isViveo ? "(Viveo)" : "na Origem (Bionexo, MVM, etc)";
  const descOriginLabel = isViveo ? "(Viveo)" : "(Bionexo, MVM, etc)";

  const periodError = useMemo(() => {
    const start = parseLocalDate(form.startDate);
    const end = parseLocalDate(form.endDate);
    if (!start || !end) return "";
    if (end < start) return "A data final não pode ser anterior à inicial.";
    const interval = Math.abs(differenceInDays(start, end)) + 1;
    if (Number.isNaN(interval)) return "Período inválido.";
    if (interval > MAX_PERIOD_DAYS)
      return `O intervalo máximo é de ${MAX_PERIOD_DAYS} dias.`;
    return "";
  }, [form.startDate, form.endDate]);

  const codesAtLimit = form.codes.length >= MAX_CHIPS;
  const descBrandAtLimit =
    form.descriptions.length + form.brands.length >= MAX_CHIPS;

  const hasAnyChip =
    form.codes.length > 0 ||
    form.descriptions.length > 0 ||
    form.brands.length > 0;

  const canSubmit =
    !!form.startDate &&
    !!form.endDate &&
    !periodError &&
    form.searchType !== null &&
    ((isCodeSearch && form.codes.length > 0) ||
      (isDescSearch &&
        (form.descriptions.length > 0 || form.brands.length > 0))) &&
    !submitting;

  // Trocar tipo de relatório — descarta chips sem diálogo (FR-F-007, US3)
  const changeType = (type: SentItemsReportType) => {
    setForm((prev) => ({
      ...prev,
      type,
      searchType: null,
      codeInput: "",
      codes: [],
      descriptionInput: "",
      descriptions: [],
      brandInput: "",
      brands: [],
    }));
    setFormError("");
  };

  const applySearchType = (searchType: DeParaSearchType) => {
    setForm((prev) => ({
      ...prev,
      searchType,
      codeInput: "",
      codes: [],
      descriptionInput: "",
      descriptions: [],
      brandInput: "",
      brands: [],
    }));
    setFormError("");
  };

  // Trocar tipo de pesquisa — exige confirmação se há chips (FR-F-008, US4)
  const selectSearchType = (searchType: DeParaSearchType) => {
    if (searchType === form.searchType) return;

    const hasCodes = form.codes.length > 0;
    const hasDesc =
      form.descriptions.length > 0 || form.brands.length > 0;

    const wouldLoseData =
      (searchType === DeParaSearchType.DESCRIPTION_BRAND && hasCodes) ||
      (searchType === DeParaSearchType.PRODUCT_CODE && hasDesc);

    if (wouldLoseData) {
      setPendingSearchType(searchType);
      return;
    }

    applySearchType(searchType);
  };

  const confirmSearchTypeChange = () => {
    if (pendingSearchType !== null) {
      applySearchType(pendingSearchType);
    }
    setPendingSearchType(null);
  };

  const cancelSearchTypeChange = () => {
    setPendingSearchType(null);
  };

  const addToken = (
    key: "codes" | "descriptions" | "brands",
    inputKey: "codeInput" | "descriptionInput" | "brandInput"
  ) => {
    setForm((prev) => {
      const raw = prev[inputKey].trim();
      if (!raw) return prev;
      const parts = raw
        .split(/[,;\n]+/g)
        .map((t) => t.trim())
        .filter((t) => t.length > 0);
      const next = [...prev[key]];
      const existing = new Set(next.map((v) => v.toLowerCase()));
      for (const p of parts) {
        if (next.length >= MAX_CHIPS) break;
        const keyLower = p.toLowerCase();
        if (!existing.has(keyLower)) {
          next.push(p);
          existing.add(keyLower);
        }
      }
      return { ...prev, [key]: next, [inputKey]: "" } as ISentItemsReportFormState;
    });
  };

  const removeToken = (
    key: "codes" | "descriptions" | "brands",
    value: string
  ) => {
    setForm((prev) => ({
      ...prev,
      [key]: prev[key].filter((v) => v !== value),
    }));
  };

  const handleInputKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    key: "codes" | "descriptions" | "brands",
    inputKey: "codeInput" | "descriptionInput" | "brandInput"
  ) => {
    if (e.key === "Enter" || e.key === "," || e.key === ";") {
      e.preventDefault();
      addToken(key, inputKey);
    }
  };

  const handleSubmit = async () => {
    if (!canSubmit) return;
    setFormError("");

    // terms: no molécula field — only codes or descriptions+brands (FR-F-010)
    const terms = isCodeSearch
      ? [...form.codes]
      : [...form.descriptions, ...form.brands];

    setSubmitting(true);
    await _reportServices.DownloadSentItemsReport({
      startDate: form.startDate,
      endDate: form.endDate,
      type: form.type,
      searchType: form.searchType,
      terms,
    });
    setSubmitting(false);
    setShowSuccessDialog(true);
  };

  const handleSuccessDialogConfirm = () => {
    setShowSuccessDialog(false);
    onClose();
  };

  // Overlay click closes only when not submitting (EC5)
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target !== e.currentTarget) return;
    if (!submitting) onClose();
  };

  const handleDialogOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target !== e.currentTarget) return;
    if (pendingSearchType !== null) {
      setPendingSearchType(null);
      return;
    }
    if (showSuccessDialog) {
      handleSuccessDialogConfirm();
    }
  };

  if (!isOpen) return null;

  const successDialog = showSuccessDialog ? (
    <DialogOverlay onMouseDown={handleDialogOverlayClick}>
      <DialogBox onMouseDown={(e) => e.stopPropagation()}>
        <DialogIcon>
          <IconMail />
        </DialogIcon>
        <DialogContent>
          <DialogTexts>
            <DialogTitle>Relatório solicitado!</DialogTitle>
            <DialogText>
              O relatório será enviado para o seu
              <br />
              e-mail em alguns instantes.
            </DialogText>
          </DialogTexts>
          <DialogButtons>
            <DialogSingleButton
              type="button"
              onClick={handleSuccessDialogConfirm}
            >
              Concluir
            </DialogSingleButton>
          </DialogButtons>
        </DialogContent>
      </DialogBox>
    </DialogOverlay>
  ) : null;

  const warningDialog =
    pendingSearchType !== null ? (
      <DialogOverlay onMouseDown={handleDialogOverlayClick}>
        <DialogBox onMouseDown={(e) => e.stopPropagation()}>
          <DialogIcon>
            <IconAlertTriangle />
          </DialogIcon>
          <DialogContent>
            <DialogTexts>
              <DialogTitle>Atenção!</DialogTitle>
              <DialogText>
                {pendingSearchType === DeParaSearchType.DESCRIPTION_BRAND ? (
                  <>
                    Para iniciar uma busca por{" "}
                    <strong>descrição/marca</strong>, os{" "}
                    <strong>códigos</strong> já adicionados serão limpos.
                    Confirma a alteração?
                  </>
                ) : (
                  <>
                    Para iniciar uma busca por <strong>códigos</strong>, os
                    dados de <strong>descrição/marca</strong> já adicionados
                    serão limpos. Confirma a alteração?
                  </>
                )}
              </DialogText>
            </DialogTexts>
            <DialogButtons>
              <DialogPrimaryButton
                type="button"
                onClick={confirmSearchTypeChange}
              >
                Confirmar
              </DialogPrimaryButton>
              <DialogOutlineButton
                type="button"
                onClick={cancelSearchTypeChange}
              >
                Cancelar
              </DialogOutlineButton>
            </DialogButtons>
          </DialogContent>
        </DialogBox>
      </DialogOverlay>
    ) : null;

  const modal = (
    <Overlay
      onMouseDown={handleOverlayClick}
      aria-modal="true"
      role="dialog"
    >
      <Dialog onMouseDown={(e) => e.stopPropagation()}>
        <HeaderRow>
          <Title>Relatório de itens enviados</Title>
          {/* CloseButton disabled during submitting to prevent mid-flight close (EC5) */}
          <CloseButton
            type="button"
            aria-label="Fechar"
            onClick={onClose}
            disabled={submitting}
          >
            <IconClose />
          </CloseButton>
        </HeaderRow>
        <Divider />

        {/* Seção 1: tipo de relatório (FR-F-003, US1) */}
        <Section>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <FieldLabel>Qual tipo de relatório deseja baixar?</FieldLabel>
            <RadioGroupRow>
              <RadioLabel $active={isViveo}>
                <HiddenRadio
                  name="sent-items-type"
                  checked={isViveo}
                  onChange={() => changeType(TypeReport.SENT_ITEMS_VIVEO)}
                />
                <RadioCircle $checked={isViveo} />
                Itens Viveo
              </RadioLabel>
              <RadioLabel $active={!isViveo}>
                <HiddenRadio
                  name="sent-items-type"
                  checked={!isViveo}
                  onChange={() => changeType(TypeReport.SENT_ITEMS_ORIGEM)}
                />
                <RadioCircle $checked={!isViveo} />
                Itens Portal de Origem
              </RadioLabel>
            </RadioGroupRow>
          </div>

          {/* Seção 2: período (FR-F-004) */}
          <PeriodRow>
            <PeriodLabel>
              <span>Selecionar período</span>
              <span>(Máx. de {MAX_PERIOD_DAYS} dias)</span>
            </PeriodLabel>
            <DateField
              value={form.startDate}
              min={MIN_DATE}
              max={form.endDate || undefined}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, startDate: e.target.value }))
              }
              aria-label="Data inicial"
            />
            <PeriodSeparator>a</PeriodSeparator>
            <DateField
              value={form.endDate}
              min={form.startDate || MIN_DATE}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, endDate: e.target.value }))
              }
              aria-label="Data final"
            />
          </PeriodRow>
          {periodError && <ErrorMessage>{periodError}</ErrorMessage>}
        </Section>

        <Divider />

        {/* Seção 3: tipo de pesquisa com textos adaptativos (FR-F-005, FR-F-006, US2, US3) */}
        <Section>
          <SectionHeader>
            <SectionHeaderTitle>
              Selecione o tipo de pesquisa
              <TooltipAnchor tabIndex={0} aria-label="Mais informações">
                <IconInfo />
                <TooltipBox role="tooltip">
                  <p>
                    Nosso sistema irá buscar apenas os termos digitados com
                    exatidão.
                  </p>
                  <p>
                    Confirme os dados digitados antes de solicitar seu
                    relatório.
                  </p>
                  <span className="tooltip-spacer" aria-hidden />
                  <p>
                    Exemplo: para obter os resultados para o código 12345,
                    digite 12345.
                  </p>
                  <p>
                    Se digitar o número incompleto, o sistema não irá encontrar
                    a referência para incluir no relatório.
                  </p>
                </TooltipBox>
              </TooltipAnchor>
            </SectionHeaderTitle>
            <SectionHeaderDescription>
              Para encontrar os resultados de itens, considere os códigos e
              descrições dos{" "}
              <strong>{isViveo ? "Itens Viveo" : "Portais de Origem"}</strong>.
            </SectionHeaderDescription>
          </SectionHeader>

          <SearchBlockList>
            {/* Busca por código */}
            <SearchBlock>
              <RadioLabel $active={isCodeSearch}>
                <HiddenRadio
                  name="sent-items-search"
                  checked={isCodeSearch}
                  onChange={() =>
                    selectSearchType(DeParaSearchType.PRODUCT_CODE)
                  }
                />
                <RadioCircle $checked={isCodeSearch} />
                Por código do produto {originLabel}
              </RadioLabel>
              <InputGroup $width={260}>
                <InputLabel>Código</InputLabel>
                <SearchInputWrapper $disabled={!isCodeSearch || codesAtLimit}>
                  <SearchInput
                    placeholder="Digite o código do produto"
                    value={form.codeInput}
                    disabled={!isCodeSearch || codesAtLimit}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        codeInput: e.target.value,
                      }))
                    }
                    onKeyDown={(e) =>
                      handleInputKeyDown(e, "codes", "codeInput")
                    }
                    onBlur={() =>
                      isCodeSearch && addToken("codes", "codeInput")
                    }
                  />
                  <IconSearch />
                </SearchInputWrapper>
                {isCodeSearch && codesAtLimit && (
                  <ErrorMessage>Limite de 100 termos atingido.</ErrorMessage>
                )}
              </InputGroup>
              {isCodeSearch && form.codes.length > 0 && (
                <ChipsBlock>
                  <ChipsLabel>Valores inseridos:</ChipsLabel>
                  <ChipsList>
                    {form.codes.map((code) => (
                      <Chip key={`code-${code}`}>
                        {code}
                        <ChipRemoveButton
                          type="button"
                          aria-label={`Remover ${code}`}
                          onClick={() => removeToken("codes", code)}
                        >
                          <IconChipClose />
                        </ChipRemoveButton>
                      </Chip>
                    ))}
                  </ChipsList>
                </ChipsBlock>
              )}
            </SearchBlock>

            {/* Busca por descrição e marca (sem Molécula — diferença central vs. DeParaReport) */}
            <SearchBlock>
              <RadioLabel $active={isDescSearch}>
                <HiddenRadio
                  name="sent-items-search"
                  checked={isDescSearch}
                  onChange={() =>
                    selectSearchType(DeParaSearchType.DESCRIPTION_BRAND)
                  }
                />
                <RadioCircle $checked={isDescSearch} />
                Por descrição ou marca {descOriginLabel}
              </RadioLabel>
              <InputsRow>
                <InputGroup $grow>
                  <InputLabel>Descrição</InputLabel>
                  <SearchInputWrapper
                    $disabled={!isDescSearch || descBrandAtLimit}
                  >
                    <SearchInput
                      placeholder="Digite a descrição do produto"
                      value={form.descriptionInput}
                      disabled={!isDescSearch || descBrandAtLimit}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          descriptionInput: e.target.value,
                        }))
                      }
                      onKeyDown={(e) =>
                        handleInputKeyDown(
                          e,
                          "descriptions",
                          "descriptionInput"
                        )
                      }
                      onBlur={() =>
                        isDescSearch &&
                        addToken("descriptions", "descriptionInput")
                      }
                    />
                    <IconSearch />
                  </SearchInputWrapper>
                </InputGroup>
                <InputGroup $grow>
                  <InputLabel>Marca</InputLabel>
                  <SearchInputWrapper
                    $disabled={!isDescSearch || descBrandAtLimit}
                  >
                    <SearchInput
                      placeholder="Digite a marca desejada"
                      value={form.brandInput}
                      disabled={!isDescSearch || descBrandAtLimit}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          brandInput: e.target.value,
                        }))
                      }
                      onKeyDown={(e) =>
                        handleInputKeyDown(e, "brands", "brandInput")
                      }
                      onBlur={() =>
                        isDescSearch && addToken("brands", "brandInput")
                      }
                    />
                    <IconSearch />
                  </SearchInputWrapper>
                </InputGroup>
              </InputsRow>
              {isDescSearch && descBrandAtLimit && (
                <ErrorMessage>Limite de 100 termos atingido.</ErrorMessage>
              )}
              {isDescSearch &&
                (form.descriptions.length > 0 || form.brands.length > 0) && (
                  <ChipsBlock>
                    <ChipsLabel>Valores inseridos:</ChipsLabel>
                    <ChipsList>
                      {form.descriptions.map((v) => (
                        <Chip key={`desc-${v}`}>
                          {`Descrição: ${v}`}
                          <ChipRemoveButton
                            type="button"
                            aria-label={`Remover descrição ${v}`}
                            onClick={() => removeToken("descriptions", v)}
                          >
                            <IconChipClose />
                          </ChipRemoveButton>
                        </Chip>
                      ))}
                      {form.brands.map((v) => (
                        <Chip key={`brand-${v}`}>
                          {`Marca: ${v}`}
                          <ChipRemoveButton
                            type="button"
                            aria-label={`Remover marca ${v}`}
                            onClick={() => removeToken("brands", v)}
                          >
                            <IconChipClose />
                          </ChipRemoveButton>
                        </Chip>
                      ))}
                    </ChipsList>
                  </ChipsBlock>
                )}
            </SearchBlock>
          </SearchBlockList>
        </Section>

        {hasAnyChip && (
          <WarningBanner>
            <IconWarning />
            <div>
              <p>O relatório será gerado com base nos valores inseridos.</p>
              <p>
                Os valores não localizados ou sem correspondência não serão
                incluídos no arquivo.
              </p>
            </div>
          </WarningBanner>
        )}

        {formError && <ErrorMessage>{formError}</ErrorMessage>}

        <FooterRow>
          <OutlineButton type="button" onClick={onClose} disabled={submitting}>
            Cancelar
          </OutlineButton>
          <PrimaryButton
            type="button"
            onClick={handleSubmit}
            disabled={!canSubmit}
          >
            {submitting ? "Enviando..." : "Solicitar relatório"}
          </PrimaryButton>
        </FooterRow>
      </Dialog>
    </Overlay>
  );

  return createPortal(
    <>
      {modal}
      {warningDialog}
      {successDialog}
    </>,
    document.body
  );
};

export default SentItemsReport;
